export enum ViewMode {
    VIEW,
    EDIT,
    INSERT,
}

export enum FileType {
    DOCUMENT = 'document',
    IDEA = 'idea',
    TEMPLATE = 'template',
}

export enum Right {
    /** Stammdaten bearbeiten */
    EDIT_MASTER_DATA = "EDIT_MASTER_DATA",
    /** PMO (alles immer schreiben und lesen) */
    PMO = "PMO",
    /** Geschäftsführer (alles immer lesen) */
    CEO = "CEO",
    /** Projekt migrieren */
    MIGRATE_PROJECT = 'MIGRATE_PROJECT',
    /** Finanz */
    FINANCE = "FINANCE",
    /** IT */
    IT = "IT",
    /** Projekt löschen */
    DELETE_PROJECT = "DELETE_PROJECT",
    /** Werksleiter */
    PLANT_MANAGEMENT = "PLANT_MANAGEMENT",
    /** FuE Mitarbeiter */
    RAD_STAFF = "RAD_STAFF",
}

export enum TeamRole {
    /** Auftraggeber */
    Orderer = 'orderer',
    /** Projektleiter */
    Lead = 'lead',
    /** Projektkunde */
    Customer = 'customer',
    /** Projektmitarbeiter */
    Employee = 'employee',
    /** Externer Projektleiter */
    LeadExternal = 'lead_external',
    /** Externer Projektmitarbeiter */
    EmployeeExternal = 'employee_external',
}

export enum ProjectTab {
    /** Idee */
    IDEA = 'idea',
    /** Ziele */
    GOALS = 'goals',
    /** Organisation */
    ORGANISATION = 'organisation',
    /** Finanz */
    COSTS = 'costs',
    /** Risiken */
    RISKS = 'risks',
    /** Stakeholder */
    STAKEHOLDER = 'stakeholder',
    /** Zeitplan */
    DATES = 'dates',
    /** Statusupdate */
    REPORTING = 'reporting',
    /** Abschluss */
    COMPLETION = 'completion',
    /** Referenzen */
    DOCUMENTS = 'documents',
    /** Freigaben */
    APPROVALS = 'approvals',
    /** Anlage */
    EXTERNAL = 'external',
}

export enum ProjectStatus {
    /**
     * Idee eingelastet
     *
     * Wird automatisch nach Erstellen gesetzt
     */
    CREATED = 'created',
    /**
     * Idee abgelehnt
     *
     * Wird bei 'Idee eingelastet' manuell gesetzt
     */
    DECLINED = 'declined',
    /**
     * An Linie übergeben
     *
     * Wird bei 'Idee eingelastet' manuell gesetzt
     */
    LINE = 'line',
    /**
     * Projektauftrag in Ausarbeitung
     *
     * Wird bei 'Idee eingelastet' manuell gesetzt
     */
    IN_ELABORATION = 'in_elaboration',
    /**
     * Projektauftrag in Prüfung
     *
     * Wird bei 'In Ausarbeitung' manuell gesetzt
     */
    EVALUATION = 'evaluation',
    /**
     * Storniert
     *
     * Wird bei 'Projektauftrag in Prüfung' manuell gesetzt
     */
    CANCELLED = 'cancelled',
    /**
     * Überarbeitung angefordert
     *
     * Wird bei 'Projektauftrag in Prüfung' manuell gesetzt
     */
    REVISE = 'revise',
    /**
     * Freigegeben
     *
     * Wird bei 'Projektauftrag in Prüfung' manuell gesetzt
     */
    RELEASED = 'released',
    /**
     * In Arbeit
     *
     * Wird bei 'Freigegeben' automatisch gesetzt
     * oder
     * Wird bei 'Projektabschluss eingereicht' manuell gesetzt
     */
    IN_PROGRESS = 'in_progress',
    /**
     * Projektabschluss eingereicht
     *
     * Wird bei 'In Arbeit' manuell gesetzt
     */
    COMPLETION_FILED = 'completion_filed',
    /**
     * Projekt abgenommen
     *
     * Wird bei 'Projektabschluss eingereicht' manuell gesetzt
     */
    COMPLETED = 'completed',
    /**
     * Projekt On Hold
     *
     * Wird von PMO manuell gesetzt
     */
    ON_HOLD = 'on_hold',
}

export enum LightTab {
    /** Allgemeines */
    GENERAL = 'general',
    /** Statusupdate */
    REPORTING = 'reporting',
}

export enum LightStatus {
    OPEN = 'Offen',
    IN_PROGRESS = 'In Arbeit',
    COMPLETED = 'Erledigt',
    ON_HOLD = 'On Hold',
}

export const strategicClassifications = [
    {
        name: "Umwelt",
        subs: ["Rohstoffe", "Energie", "Abfall"]
    },
    {
        name: "Kunden",
        subs: ["Marktentwicklung", "Kundenlösungen", "Kapazitätserweiterung"]
    },
    {
        name: "MitarbeiterInnen",
        subs: ["Unternehmenskultur", "Arbeitsplatz & Umfeld", "Leistungen für ArbeitnehmerInnen"]
    },
    {
        name: "Innovation",
        subs: ["Ideenmanagement", "Produkt und Service", "Technologie und Prozess"]
    },
    {
        name: "Effizienz",
        subs: ["Prozessmanagement", "Projektmanagement", "Kommunikation"]
    },
];
